import { _ as __decorate, a as __metadata } from '../tslib.es6-Cv888lzs.js';
import { BaseComponent } from '@italia/globals';
import { css, html as html$1 } from 'lit';
import { unsafeStatic, html } from 'lit/static-html.js';
import { property, query, customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { when } from 'lit/directives/when.js';

var styles = css`@charset "UTF-8";
.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.callout {
  --bsi-callout-background-color: var(--bsi-page-background-color);
  --bsi-callout-border-color: var(--bsi-color-border-secondary);
  --bsi-callout-border-size: 2px;
  --bsi-callout-font-family: var(--bsi-font-sans);
  --bsi-callout-icon-color: var(--bsi-icon-secondary);
  --bsi-callout-inner-spacing: var(--bsi-spacing-m);
  --bsi-callout-outer-spacing: var(--bsi-spacing-l);
  --bsi-callout-text-color: var(--bsi-color-text-secondary);
  --bsi-callout-text-font-size: var(--bsi-body-font-size);
  --bsi-callout-title-color: var(--bsi-color-text-secondary);
  --bsi-callout-title-font-size: var(--bsi-heading-6-font-size);
  --bsi-callout-title-font-weight: var(--bsi-heading-font-weight-weak);
}

/* stylelint-disable-next-line no-duplicate-selectors */
.callout {
  position: relative;
  overflow: hidden;
  background-color: var(--bsi-callout-background-color);
  color: var(--bsi-callout-text-color);
}
.callout .callout-inner {
  padding: var(--bsi-callout-inner-spacing);
  border: var(--bsi-callout-border-size) solid var(--bsi-callout-border-color);
  margin: var(--bsi-callout-outer-spacing) 0;
}
.callout.callout-highlight {
  border: none;
  border-left: var(--bsi-callout-border-size) solid var(--bsi-callout-border-color);
  border-radius: 0;
  padding: 0 var(--bsi-callout-inner-spacing);
}
.callout p {
  color: var(--bsi-callout-text-color);
  font-family: var(--bsi-callout-font-family);
  font-size: var(--bsi-callout-text-font-size);
}
.callout p.callout-big-text {
  font-size: var(--bsi-lead-font-size);
}
.callout p:last-child {
  margin: 0;
}
.callout .callout-title {
  display: flex;
  align-items: center;
  margin-bottom: var(--bsi-spacing-s);
  color: var(--bsi-callout-title-color);
  font-family: var(--bsi-callout-font-family);
  font-size: var(--bsi-callout-title-font-size);
  font-weight: var(--bsi-callout-title-font-weight);
  text-transform: uppercase;
}
.callout .icon {
  fill: var(--bsi-callout-icon-color);
  margin-right: var(--bsi-icon-spacing);
}
.callout-primary {
  --bsi-callout-border-color: var(--bsi-color-border-primary);
  --bsi-callout-title-color: var(--bsi-color-text-primary);
  --bsi-callout-icon-color: var(--bsi-icon-primary);
}
.callout-success {
  --bsi-callout-border-color: var(--bsi-color-border-success);
  --bsi-callout-title-color: var(--bsi-color-text-success);
  --bsi-callout-icon-color: var(--bsi-icon-success);
}
.callout-warning {
  --bsi-callout-border-color: var(--bsi-color-border-warning);
  --bsi-callout-title-color: var(--bsi-color-text-warning);
  --bsi-callout-icon-color: var(--bsi-icon-warning);
}
.callout-danger {
  --bsi-callout-border-color: var(--bsi-color-border-danger);
  --bsi-callout-title-color: var(--bsi-color-text-danger);
  --bsi-callout-icon-color: var(--bsi-icon-danger);
}
.callout-highlight {
  --bsi-callout-border-radius: 0;
  padding: 0 var(--bsi-spacing-m);
  border: none;
  border-left: var(--bsi-callout-border-size) solid var(--bsi-callout-border-color);
}
.callout-highlight .callout-title {
  margin-bottom: var(--bsi-spacing-s);
}
.callout-more {
  position: relative;
  padding: var(--bsi-spacing-l);
  border: none;
  border-radius: 0;
  background: #f9f9f5;
}
.callout-more:before, .callout-more:after {
  position: absolute;
  top: 0;
  right: 0;
  content: "";
  width: 0;
  height: 0;
  border-style: solid;
}
.callout-more:before {
  border-width: 0 48px 48px 0;
  border-color: transparent var(--bsi-page-background) transparent transparent;
}
.callout-more:after {
  border-width: 48px 0 0 48px;
  border-color: transparent transparent transparent #e4e4db;
}
.callout-more p {
  color: var(--bsi-color-text-secondary);
  font-size: 1rem;
  line-height: 1.5rem;
}
.callout-more .callout-title {
  align-items: flex-start;
  margin-bottom: 2.222rem;
}
.callout-more .callout-title i {
  font-size: 1.25rem;
}
.callout-more .callout-title span {
  display: inline-block;
  margin-top: -0.111rem;
  padding-bottom: 0.1rem;
}
.callout .collapse-div {
  display: flex;
  flex-direction: column-reverse;
  border-bottom: none;
}
.callout .collapse-div .collapse-header {
  display: flex;
  justify-content: space-between;
  margin-top: 0;
  padding: var(--bsi-spacing-m) 0 0;
  border-top: 1px solid var(--bsi-color-border-subtle);
}
.callout .collapse-div .collapse-header .callout-more-toggle {
  display: flex;
  align-items: center;
  width: auto;
  padding: 0;
  border: none;
  background-color: transparent;
  color: var(--bsi-color-link);
  font-weight: normal;
}
.callout .collapse-div .collapse-header .callout-more-toggle:hover, .callout .collapse-div .collapse-header .callout-more-toggle:focus, .callout .collapse-div .collapse-header .callout-more-toggle:active {
  background: none;
}
.callout .collapse-div .collapse-header .callout-more-toggle:hover {
  color: var(--bsi-color-link-hover);
}
.callout .collapse-div .collapse-header .callout-more-toggle:hover span {
  border-color: var(--bsi-color-link-hover);
}
.callout .collapse-div .collapse-header .callout-more-toggle:hover span:before, .callout .collapse-div .collapse-header .callout-more-toggle:hover span:after {
  background: var(--bsi-color-link-hover);
}
.callout .collapse-div .collapse-header .callout-more-toggle:active {
  color: var(--bsi-color-link-active);
}
.callout .collapse-div .collapse-header .callout-more-toggle:before, .callout .collapse-div .collapse-header .callout-more-toggle:after {
  display: none;
}
.callout .collapse-div .collapse-header .callout-more-toggle span {
  position: relative;
  display: inline-block;
  width: 15px;
  height: 15px;
  margin-top: 0.111rem;
  margin-left: 0.444rem;
  border: 1px solid var(--bsi-color-text-primary);
  border-radius: 50%;
}
.callout .collapse-div .collapse-header .callout-more-toggle span:before, .callout .collapse-div .collapse-header .callout-more-toggle span:after {
  position: absolute;
  content: "";
  background: var(--bsi-color-background-primary);
}
.callout .collapse-div .collapse-header .callout-more-toggle span:before {
  top: 6px;
  left: 2px;
  width: 9px;
  height: 1px;
}
.callout .collapse-div .collapse-header .callout-more-toggle span:after {
  top: 0;
  left: 6px;
  width: 1px;
  height: 9px;
  transform: translateY(2px);
  transition: transform 0.2s;
}
.callout .collapse-div .collapse-header .callout-more-toggle[aria-expanded=true] span:after {
  transform: translateY(2px) rotate(90deg);
}
.callout .collapse-div .collapse-header .callout-more-download {
  margin-left: auto;
  font-weight: normal;
}
.callout .collapse-div .collapse-body {
  padding: 0;
}
.callout .collapse-div .collapse-body p:last-child {
  margin-bottom: 1rem;
}

:host {
  display: block;
  --bsi-callout-text-size: 16px;
  --bsi-callout-font-family: Lora, Georgia, serif;
}

/* Anti-FOUC: nascondi il contenuto finché il componente non è definito */
:host(:not(:defined)) {
  visibility: hidden;
}

:host([big-text]) {
  --bsi-callout-text-size: 18px;
}

:host ::slotted(it-icon[slot=icon]) {
  margin-right: var(--bsi-spacing-xxs);
}

:host ::slotted(*[slot=title]) {
  margin: 0;
}

.callout-title {
  display: flex;
  align-items: center;
}
.callout-title .text h1,
.callout-title .text h2,
.callout-title .text h3,
.callout-title .text h4,
.callout-title .text h5,
.callout-title .text h6 {
  display: inline-flex;
  padding: 0;
  border: 0;
  margin: 0;
  color: inherit;
  font-size: var(--bsi-callout-title-font-size);
  font-weight: var(--bsi-callout-title-font-weight);
  line-height: inherit;
  text-transform: uppercase;
}

.callout-highlight .callout-title .text h1,
.callout-highlight .callout-title .text h2,
.callout-highlight .callout-title .text h3,
.callout-highlight .callout-title .text h4,
.callout-highlight .callout-title .text h5,
.callout-highlight .callout-title .text h6,
.callout-more .callout-title .text h1,
.callout-more .callout-title .text h2,
.callout-more .callout-title .text h3,
.callout-more .callout-title .text h4,
.callout-more .callout-title .text h5,
.callout-more .callout-title .text h6 {
  display: inline-flex;
}

.callout-more .callout-title {
  display: flex;
  align-items: center;
}

::slotted(it-icon[slot=icon]) {
  --bsi-icon-default: var(--it-color-border-secondary);
}`;

let ItCallout = class ItCallout extends BaseComponent {
    constructor() {
        super(...arguments);
        this.variant = '';
        this.highlight = false;
        this.calloutMore = false;
        this.bigText = false;
        this.headingLevel = 'h2';
        this.onIconSlotChange = () => {
            // Usa requestAnimationFrame per dare tempo al DOM di stabilizzarsi
            requestAnimationFrame(() => {
                this.updateIconColors();
            });
        };
    }
    updateMoreContentBigText() {
        if (!this.shadowRoot)
            return;
        const slot = this.shadowRoot.querySelector('slot[name="more-content"]');
        if (!slot)
            return;
        const assigned = slot.assignedElements({ flatten: true });
        assigned.forEach((el) => {
            if (el.tagName?.toLowerCase() === 'it-callout-more') {
                if (this.bigText) {
                    el.setAttribute('big-text', '');
                }
                else {
                    el.removeAttribute('big-text');
                }
            }
        });
    }
    getCalloutClasses() {
        return classMap({
            callout: true,
            [`callout-${this.variant}`]: !!this.variant && !this.calloutMore,
            'callout-highlight': this.highlight,
            'callout-more': this.calloutMore,
        });
    }
    updateIconColors() {
        if (!this._iconSlot || !this.variant)
            return;
        const assignedIcons = this._iconSlot.assignedElements();
        assignedIcons.forEach((icon) => {
            if (icon instanceof HTMLElement && icon.tagName?.toLowerCase() === 'it-icon') {
                icon.setAttribute('color', this.variant);
            }
        });
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        // Se cambia la variante, aggiorna i colori delle icone
        if (changedProperties.has('variant')) {
            this.updateIconColors();
        }
        // Propaga big-text a it-callout-more
        if (changedProperties.has('bigText')) {
            this.updateMoreContentBigText();
        }
        // Aggiorna sempre dopo ogni update (slotchange non sempre triggera updated)
        this.updateMoreContentBigText();
    }
    renderTitle() {
        const headingTag = unsafeStatic(this.headingLevel);
        const headingId = `${this._id}-title`;
        return html$1 `
      <div class="callout-title" part="title">
        <slot name="icon" @slotchange="${this.onIconSlotChange}"></slot>
        <div class="text">
          ${html `
            <${headingTag} id="${headingId}">
              <slot name="title"></slot>
            </${headingTag}>
          `}
        </div>
      </div>
    `;
    }
    renderInner() {
        return html$1 `
      <div class="callout-inner" part="inner">
        ${this.renderTitle()}
        <slot></slot>
        <slot name="more-content"></slot>
      </div>
    `;
    }
    renderHighlightContent() {
        return html$1 `
      ${this.renderTitle()}
      <slot></slot>
      <slot name="more-content"></slot>
    `;
    }
    render() {
        const headingId = `${this._id}-title`;
        return html$1 `
      <section class="${this.getCalloutClasses()}" part="callout" aria-labelledby="${headingId}">
        ${when(!this.highlight && !this.calloutMore, () => html$1 ` ${this.renderInner()} `, () => this.renderHighlightContent())}
      </section>
    `;
    }
};
ItCallout.styles = styles;
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", String)
], ItCallout.prototype, "variant", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItCallout.prototype, "highlight", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'callout-more' }),
    __metadata("design:type", Object)
], ItCallout.prototype, "calloutMore", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'big-text' }),
    __metadata("design:type", Object)
], ItCallout.prototype, "bigText", void 0);
__decorate([
    property({ type: String, reflect: true, attribute: 'heading-level' }),
    __metadata("design:type", String)
], ItCallout.prototype, "headingLevel", void 0);
__decorate([
    query('slot[name="title"]'),
    __metadata("design:type", HTMLSlotElement)
], ItCallout.prototype, "_titleSlot", void 0);
__decorate([
    query('slot[name="icon"]'),
    __metadata("design:type", HTMLSlotElement)
], ItCallout.prototype, "_iconSlot", void 0);
ItCallout = __decorate([
    customElement('it-callout')
], ItCallout);

export { ItCallout };
//# sourceMappingURL=it-callout.js.map
